/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Period_EndInputs */



/**
* | output |
* | --- |
* | "Current Period End" |
*
* @param {Period_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const period_end = /** @type {((inputs?: Period_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Period_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fin de la période actuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ende der aktuellen Periode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fine del periodo corrente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Конец текущего периода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fin del período actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("本期末")
	if (locale === "ja") return /** @type {LocalizedString} */ ("当期末")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान अवधि की समाप्ति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fim do período atual")
	return /** @type {LocalizedString} */ ("Current Period End")
});